import {createContext, useContext} from 'react';

/*
 * Props.
 */

export interface FrameContextProps {
  updateTitle: (arg: string) => void;
}

/*
 * Context.
 */

export const FrameContext = createContext<FrameContextProps>({updateTitle: () => {}});

/*
 * Hook.
 */

export function useFrameContext() {
  return useContext(FrameContext);
}
